import { render, staticRenderFns } from "./PaniereSupplierDetailsDialog.vue?vue&type=template&id=1aa91fde&scoped=true"
import script from "./PaniereSupplierDetailsDialog.vue?vue&type=script&lang=js"
export * from "./PaniereSupplierDetailsDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1aa91fde",
  null
  
)

export default component.exports